// extracted by mini-css-extract-plugin
export default {"sidebar":"style_sidebar__lXdBa","logo":"style_logo__F50iT","footer":"style_footer__lGFA2","content":"style_content__35fVE"};